import React from 'react';
import { Icon } from 'antd';
import { deleteLoadFlag } from '../../../../project/bussInit';

export const LogoutHandler = () => {
  console.log('登出');
  let success = function (res) {
    tool.sgiLogger.info(res, 'indexPclogout');
    if (res && res.head.code == '0000') {
      let allCookieKey = tool.getCookie('allCookieKey');
      if (allCookieKey) {
        let arr = allCookieKey.split(',');
        arr.forEach((key) => {
          tool.deleteCookie(key);
        });
        tool.deleteCookie('allCookieKey');
      } else {
        tool.deleteCookie('token');
      }
      // 清理业务标准代码缓存
      deleteLoadFlag();
      const openSso = tool.getCookie('openSso');
      const service = window.location.protocol + '//' + window.location.host + '/';
      if (openSso) {
        let url = sgiConfig.casBaseUrl + '/logout?service=' + encodeURIComponent(service);
        console.log('useSso.ts  ssoLoginOut  url: ', url);
        window.location.href = url;
        return;
      }
      // tool.popSingleUI('/');
      // tool.popSingleUI('/?openSso=false');
      let path = openSso ? '/' : '/?openSso=false';
      console.log('path', path);
      tool.popSingleUI(path);
    }
  };
  commonClient.simplecall(sgiConfig.allUrl.logoutUri, '', success, true);
};

export default function Logout(props) {
  return (
    <div className={props.className} onClick={LogoutHandler}>
      <Icon type="logout" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/operation/Logout.js